export const cardDelivery = {
    showAlertText: false,
    showNewDeliveryContact: true,
    useContacts: false,
};
